import { useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { trackEvent } from "../lib/track";

export function useWatchlist() {
  const { user, patchUser } = useAuth();
  const list = (user && user.watchlist) || [];

  const inList = useCallback((id) => list.includes(id), [list]);

  const toggle = useCallback(
    async (item) => {
      const id = typeof item === "string" ? item : item.id;
      const title = typeof item === "string" ? "Title" : item.title;
      const has = list.includes(id);
      // optimistic
      const next = has ? list.filter((x) => x !== id) : [...list, id];
      patchUser({ watchlist: next });
      try {
        if (has) {
          await api.delete(`/watchlist/${id}`);
          toast(`Removed "${title}" from My List`);
        } else {
          await api.post("/watchlist", { id });
          trackEvent("watchlist_add", { title_id: id });
          toast(`Added "${title}" to My List`);
        }
      } catch {
        patchUser({ watchlist: list }); // revert
        toast.error("Could not update My List");
      }
    },
    [list, patchUser]
  );

  return { list, inList, toggle };
}
